import React , { useState } from "react";
import './QueryBot.css';

import BotButton from "../../components/BotButton/BotButton";
import ChatBox from "../../components/ChatBox/ChatBox";

const QueryBot = () => {

    const [openBot, setOpenBot] = useState(false);

    return(
        <div className={ openBot ? "bot-container open" : "bot-container close" }>
            {
                openBot ? 
                <>
                    <div className="chatbox-backdrop"></div>
                    <ChatBox close={ (confirm)=>{ setOpenBot(confirm) } }/>
                </>
                :
                <BotButton open={ ()=>{ setOpenBot(true) } }/>
            }
        </div>
    )
}

export default QueryBot;
